export default __webpack_public_path__ + "static/unamanera-7e84a761cc1227282e9bb6898ffcd031.jpg";